import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const FormContainer = styled(Box)`
  ${() => css`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    width: 100%;
  `}
`

export const WarningBanner = styled(Box)`
  ${() => css`
    width: 100%;
    padding: 0.75rem 1rem;
    background-color: #fffbeb;
    border: 1px solid #f59e0b;
    border-radius: 8px;
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    margin-bottom: 0.5rem;

    svg {
      color: #f59e0b;
      flex-shrink: 0;
      margin-top: 0.125rem;
    }
  `}
`

export const WarningText = styled.p`
  ${() => css`
    margin: 0;
    font-size: 0.875rem;
    color: #92400e;
    line-height: 1.5;
  `}
`

export const SwitchContainer = styled(Box)`
  ${() => css`
    display: flex;
    align-items: center;
    gap: 0.75rem;
  `}
`

export const CalculationText = styled.p`
  ${() => css`
    margin: -0.5rem 0 0 0;
    font-size: 0.75rem;
    color: #64748b;
    line-height: 1.5;
  `}
`

export const ProportionalSalaryContainer = styled(Box)`
  ${() => css`
    margin-top: 0.5rem;
  `}
`
